import { WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { ConsoleSpanExporter, SimpleSpanProcessor, SpanProcessor } from '@opentelemetry/sdk-trace-base';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { ATTR_SERVICE_NAME, ATTR_SERVICE_VERSION, SEMRESATTRS_DEPLOYMENT_ENVIRONMENT } from '@opentelemetry/semantic-conventions';
import { XMLHttpRequestInstrumentation } from '@opentelemetry/instrumentation-xml-http-request';
import { FetchInstrumentation } from '@opentelemetry/instrumentation-fetch';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';

const otlpEndpoint = process.env.REACT_APP_OTLP_ENDPOINT;
const spanProcessors: SpanProcessor[] = [];
const isProduction = process.env.NODE_ENV === 'production' || process.env.REACT_APP_STAGE === 'staging' || process.env.REACT_APP_STAGE === 'production';

const isSecureEndpoint = (url: string): boolean => {
  return url.startsWith('https://') || url.startsWith('http://localhost') || url.startsWith('http://127.0.0.1');
};

// Configurar OTLP con timeout corto para evitar bloqueos
if (otlpEndpoint && isSecureEndpoint(otlpEndpoint)) {
  spanProcessors.push(new SimpleSpanProcessor(new OTLPTraceExporter({
    url: otlpEndpoint,
    //Manuel acá se esta limitando el tiempo de espera del servidor de telemetricas /agregue las siguientes 2 lineas
    headers: {},
    timeoutMillis: 2000, // 2 segundos máximo
  })));
} else if (otlpEndpoint && !isSecureEndpoint(otlpEndpoint)) {
  // HTTP endpoint not on localhost — skip to avoid mixed content / insecure requests
} else if (!isProduction) {
  // Solo usar ConsoleSpanExporter en development
  spanProcessors.push(new SimpleSpanProcessor(new ConsoleSpanExporter()));
}
// En staging/production sin OTLP endpoint: no exportar traces (spanProcessors queda vacío)

// Configurar el proveedor de trazas
const provider = new WebTracerProvider({
  resource: resourceFromAttributes({
    [ATTR_SERVICE_NAME]: 'eca-app',
    [ATTR_SERVICE_VERSION]: '1.0.0',
    [SEMRESATTRS_DEPLOYMENT_ENVIRONMENT]: process.env.NODE_ENV || 'development',
  }),
  spanProcessors,
});
// Registrar el proveedor
provider.register();

// Configurar las instrumentaciones
const instrumentations = [
  // Instrumentación de XMLHttpRequest (para llamadas AJAX)
  new XMLHttpRequestInstrumentation({
    enabled: true,
    ignoreUrls: [/localhost:3000/],
    propagateTraceHeaderCorsUrls: /.*/,
  }),
  // Instrumentación de Fetch API
  new FetchInstrumentation({
    enabled: true,
    propagateTraceHeaderCorsUrls: /.*/,
  }),
  // Otras auto-instrumentaciones web
  ...getWebAutoInstrumentations()
];

// Registrar todas las instrumentaciones
registerInstrumentations({
  instrumentations,
});

// Crear un tracer para uso manual
const tracer = provider.getTracer('eca-app-tracer');

// Exportar el tracer para uso en la aplicación
export { tracer };